import {Component} from "react";
import ChromeImage from "@browser-logos/chrome/chrome.png";
import * as React from "react";
import './SupportedBrowser.css';

type browserDetected = 'Safari' | 'Opera' | 'Chrome' | 'IE' | 'Firefox' | 'Edge' | 'Unknown';
const ChromeBrowser = 'Chrome';
const UnknownBrowser = 'Unknown';
const browserFound = detectBrowser();
function detectBrowser(): browserDetected {
    if(navigator.userAgent.indexOf('MSIE') > -1){
        return 'IE';
    }
    if(navigator.userAgent.indexOf('Firefox') > -1){
        return 'Firefox';
    }
    if(navigator.appVersion.indexOf('Edge') > -1){
        return 'Edge';
    }
    let chrome = navigator.userAgent.indexOf('Chrome') > -1;
    const opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
    if ((chrome) && (opera)){
        return 'Opera'
    }
    if(chrome){
        return ChromeBrowser;
    }
    return UnknownBrowser;
}

export class SupportedBrowsers extends Component {

    render() {
        const isSupportedBrowser = browserFound == ChromeBrowser;
        const browserClass = 'browser-icon' + (isSupportedBrowser ? ' ' : ' gray-img');
        return <>
                <span>
                    Supported Browsers :&nbsp;
                </span>
                <span>
                    <img className={browserClass} src={ChromeImage} alt="Chrome" width="50"/>
                </span>
        </>
    }
}
